import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestType } from "../../types/common";
import { checkChanceType, sendScoreType } from "../../types/game";
interface gameType {
  sendScore: requestType<sendScoreType>;
  checkChance: requestType<checkChanceType>;
  isPlayGame: boolean;
  chnace?: number;
  special_chance?: number;
}
const initialState: gameType = {
  sendScore: { loading: false },
  checkChance: { loading: false },
  isPlayGame: false,
};
export const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    setLoadingScore(state, action: PayloadAction<boolean>) {
      state.sendScore.loading = action.payload;
    },
    setSendScore(state, action: PayloadAction<sendScoreType>) {
      state.sendScore.loading = false;
      state.sendScore.data = action.payload;
      state.sendScore.error = null;
    },
    setErrorScore(state, action: PayloadAction<any>) {
      state.sendScore.loading = false;
      state.sendScore.error = action.payload;
      state.sendScore.data = null;
    },
    setLoadingCheck(state, action: PayloadAction<boolean>) {
      state.checkChance.loading = action.payload;
    },
    setCheckChance(state, action: PayloadAction<checkChanceType>) {
      state.checkChance.loading = false;
      state.checkChance.data = action.payload;
    },

    setIsPalyGame(state, action: PayloadAction<boolean>) {
      state.isPlayGame = action.payload;
    },
    setChance(state, action: PayloadAction<number>) {
      state.chnace = action.payload;
    },
    setSpecialChance(state, action: PayloadAction<number>) {
      state.special_chance = action.payload;
    },
  },
});
export const gameAction = gameSlice.actions;
export default gameSlice.reducer;
